import { CONFIG_ACTION_TYPES, READING_ACTION_TYPES } from '../actions/action_types';

const ALWAYS_SHOW_SENTENCE_NUMBERS = 'always-show-sentence-numbers';

const CONFIGURABLE_ACTIVITIES = {
  ACTIVITIES: 'activities',
  REVEAL_WORDS: 'reveal-words',
  POST_READING: 'post-reading',
  GRAPHIC_ORGANIZARER: 'graphic-organizer',
  ALL_ACTIVITES: 'all-activities',
};

const isActivityActive = (availableActivities, activity) => (
  !availableActivities
  || availableActivities.indexOf(CONFIGURABLE_ACTIVITIES.ALL_ACTIVITES) > -1
  || availableActivities.indexOf(activity) > -1
);

export const initialState = {
  hasActivities: false,
  hasRevealWords: false,
  hasPostReading: false,
  hasGraphicOrganizer: false,
  alwaysShowSentenceNumbers: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CONFIG_ACTION_TYPES.SET_CONFIG:
      return {
        ...state,
        alwaysShowSentenceNumbers: (
          payload.settings && payload.settings.indexOf(ALWAYS_SHOW_SENTENCE_NUMBERS) > -1
        ) || false,
        hasActivities: isActivityActive(payload.activities, CONFIGURABLE_ACTIVITIES.ACTIVITIES),
        hasRevealWords: isActivityActive(payload.activities, CONFIGURABLE_ACTIVITIES.REVEAL_WORDS),
        hasPostReading: isActivityActive(payload.activities, CONFIGURABLE_ACTIVITIES.POST_READING),
        hasGraphicOrganizer: isActivityActive(payload.activities, CONFIGURABLE_ACTIVITIES.GRAPHIC_ORGANIZARER),
      };

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default:
      return state;
  }
};
